/**
 * Program Category Badge Component
 */

import Badge from '@cloudscape-design/components/badge';

export type ProgramCategory = 'Technical' | 'Certification' | 'Sales' | 'Leadership';

/**
 * Render category badge component
 * All categories use grey to maintain visual hierarchy
 */
export function CategoryBadge({ category }: { category: string }) {
  return <Badge color="grey">{category}</Badge>;
}
